import React from 'react';

export const AccountMonitoringContext = React.createContext({ peerGroupId: '' });
